import { NgModule } from '@angular/core';
import { OpportunityService } from './services/opportunity.service';

@NgModule({
  providers: [OpportunityService],
})
export class OpportunitiesModule {}
